import { Modal, Group } from "@mantine/core";
import { CDN_URL } from "../../../constant";

const ThreedSpotPopUp = ({
	isInfoThreeDSpotOpen,
	setIsInfoThreeDSpotOpen,
	infoThreeDSpotDetails,
}) => {
	return (
		<>
			<Modal
				centered
				size="lg"
				opened={isInfoThreeDSpotOpen}
				onClose={() => setIsInfoThreeDSpotOpen(false)}
				title={infoThreeDSpotDetails.name}
				styles={{
					modal: { backgroundColor: "Transparent" },
					title: { color: "#ffffff", fontWeight: "700" },
				}}
			>
				<Group
					position="center"
					style={{ width: "100%", height: "500px" }}
				>
					<model-viewer
						style={{
							width: "100%",
							height: "100%",
						}}
						camera-controls
						src={CDN_URL + infoThreeDSpotDetails.url}
					/>
				</Group>
			</Modal>
		</>
	);
};

export default ThreedSpotPopUp;
